import { render } from "./AddEnvelope.vue?vue&type=template&id=73e97603"
import script from "./AddEnvelope.vue?vue&type=script&lang=js"
export * from "./AddEnvelope.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__